<template>
  <div class="filter-wishlist" id="filter-wishlist" v-if="isEnable() && isReadyComponent()">
    <div class="filter-wishlist__row">
      <div class="block">
        <div class="filter-wishlist__search">
          <label class="form-label">Поисковый запрос</label>
          <div class="input-group">
            <div class="input-icon">
              <input @keyup.enter="events.onSearch" type="text" v-model="bootData.search" class="form-control" placeholder="Поисковый запрос">
              <button class="btn input-icon-addon__button" @click="events.onSearch">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="10" cy="10" r="7" />
                  <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="filter-wishlist__date">
          <label class="form-label">Дата создания</label>
          <Datepicker auto-apply v-model="bootData.date" @update:modelValue="events.applyDate" range multi-calendars locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" />
        </div>
      </div>
      <div class="block">
        <div class="filter-wishlist__select users">
          <UniversalSelect
              v-model="bootData.users"
              mode="tags"
              :searchable="true"
              :options="formattedUsers"
              :disabled="isUsersLoading"
              :loading="isUsersLoading"
              label="Пользователь"
              placeholder="Не выбрано"
              :default-image="defaultImage"
              @onChange="events.onUser" />
        </div>
      </div>
      <div class="block">
        <div class="filter-wishlist__categories">
          <UniversalSelect
              v-model="bootData.categories"
              mode="tags"
              :searchable="true"
              :options="formattedCategories"
              :disabled="isCategoriesLoading"
              :loading="isCategoriesLoading"
              label="Категория"
              placeholder="Не выбрано"
              :default-image="defaultImage"
              @onChange="events.onCategories" />
        </div>
      </div>
      <div class="block">
        <div class="filter-wishlist__is-moderate">
          <UniversalSelect
              v-model="bootData.is_moderate"
              mode="single"
              :searchable="false"
              :options="formattedModerated"
              :disabled="isUsersLoading"
              :loading="isUsersLoading"
              label="Модерация"
              placeholder="Не выбрано"
              @onChange="events.onIsModerate" />
        </div>
      </div>
      <div class="block">
        <div class="filter-wishlist__is-moderate">
          <SelectThemes
              v-model="bootData.themes"
              @change="events.onThemes"
          />
        </div>
      </div>
      <div class="block">
        <div class="show-options" @click="showOptions()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-caret-up-down">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M18 10l-6 -6l-6 6h12" />
            <path d="M18 14l-6 6l-6 -6h12" />
          </svg>
        </div>
      </div>
    </div>
    <div class="filter-wishlist__options" v-show="isShowOptions()">
      <div class="filter-wishlist__row">
        <div class="block">
          <div class="filter-wishlist__is-moderate">
            <UniversalSelect
                v-model="bootData.wishlists"
                mode="tags"
                :searchable="true"
                :options="formattedWishlists"
                :disabled="isWishlistsLoading"
                :loading="isWishlistsLoading"
                label="Вишлист"
                placeholder="Не выбрано"
                :default-image="defaultImage"
                @onChange="events.onWishlists" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, defineOptions} from "vue"
import Datepicker from "@/plugins/datepicker"
import UniversalSelect from "@/components/select_universal/Index"
import SelectThemes from "../themes/Index"
import { useFilter } from './Filter.js'

import { MODERATED_OPTIONS } from "./moderation"
import { useUsers } from "./composables/useUsers"
import {useCategories} from "@/modules/wishlist/components/filter/composables/useCategories"
import {useWishlists} from "@/modules/wishlist/components/filter/composables/useWishlists"

defineOptions({
  name: "WishlistFilter"
})

const props = defineProps({
  enable: { type: Boolean, required: true },
  params: { type: Object, required: true },
  payload: { type: Object, default: () => ({}) },
  defaultImage: {
    type: String,
    default: "/assets/static/user/no_image.jpg"
  }
})

const emit = defineEmits(['onChange', 'onSearch', 'applyDate', 'onUser', 'onCategories', 'onIsModerate'])

const {
  events,
  bootData,
  isEnable,
  isReadyComponent,
  showOptions,
  isShowOptions,
} = useFilter(props, { emit })

const formattedModerated = ref(MODERATED_OPTIONS)
const { formattedUsers, isLoading: isUsersLoading, fetchUsers } = useUsers()
const { formattedCategories, isLoading: isCategoriesLoading, fetchCategories } = useCategories()
const { formattedWishlists, isLoading: isWishlistsLoading, fetchWishlists } = useWishlists()

const loadData = async () => {
  await fetchUsers()
  await fetchCategories()
  await fetchWishlists()
}

onMounted(loadData)
</script>

<style scoped src="./style.css"></style>
